<template>
  <MountingPortal mountTo="#second">
    <div id="secondslide">
      <div class="headingsecondslide">
        About
        <div id="span"></div>
      </div>
      <div class="imageandstart">
        Hello peeps! I am <b>Sai Prachodhan Devulapalli</b> from Telangana,
        India. I am persuing my Undergraduate course in Electrical Engineering
        department at Indian Institute of Technology, Hyderabad. Basically I am
        a <b>front end web developer</b> with some basics of Backend with
        <b>flask</b>(python) and <b>Express</b>(JS). I like projects related to
        Electrical engineering in combination with coding and I am a part-time
        <b>freelancer</b>.
      </div>
      <div class="flexbox">
        <div class="image" data-aos="fade-right" data-aos-once="true">
          <img
            src="../components/images/say-hello-to-new-people.svg"
            alt="Image"
          />
        </div>
        <div class="textsecond" data-aos="fade-left" data-aos-once="true">
          <h3 class="headingtextsecond">My Details</h3>
          I am a Student developer and passionate about knowing new things.
          Presently I am learning Vue and Gatsby. I have done couple of some
          college websites and
          <b
            ><span
              style="cursor:pointer;text-decoration:underline;"
              v-on:click="scrolltoproject"
              >projects</span
            ></b
          >
          <div class="items">
            <div>
              <i class="fas fa-chevron-right" style="color:#149DDD"></i>
              <b>&nbsp;&nbsp;&nbsp;Name</b>: Sai Prachodhan Devulapalli
            </div>
            <div>
              <i class="fas fa-chevron-right" style="color:#149DDD"></i>
              <b>&nbsp;&nbsp;&nbsp;Degree</b>: BTECH, Electrical Engineering
            </div>
            <div>
              <i class="fas fa-chevron-right" style="color:#149DDD"></i>
              <b>&nbsp;&nbsp;&nbsp;College</b>: Indian Institute of Technology,
              Hyderabad
            </div>
            <div>
              <i class="fas fa-chevron-right" style="color:#149DDD"></i>
              <b>&nbsp;&nbsp;&nbsp;Email</b>:
              <a
                href="mailto:devulapallisaiprachodhan26@gmail.com"
                style="text-decoration:none;color:#149DDD"
                >devulapallisaiprachodhan26@gmail.com</a
              >
            </div>
            <div>
              <i class="fas fa-chevron-right" style="color:#149DDD"></i>
              <b>&nbsp;&nbsp;&nbsp;Contact No</b>: 9160571016
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  </MountingPortal>
</template>

<script>
export default {
  name: "Secondslide",
  secondheight: 0,
  methods: {
    scrolltoproject() {
      console.log("Scroll to project");
      // scrolling to projects section
    },
  },
  beforeMount() {
    this.secondheight = window.innerHeight;
  },
};
</script>

<style scoped>
.items {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
}
.items div {
  padding-top: 3px;
  padding-bottom: 3px;
}
.imageandstart {
  font-family: "Poppins", sans-serif;
  font-size: 1.2rem;
  margin-left: 2.2vw;
  margin-right: 2.2vw;
  margin-bottom: 2vh;
}
.headingtextsecond {
  font-family: "Zen Antique Soft", serif;
  color: #173b6c;
  font-size: 1.8rem;
}
.textsecond {
  width: 43.6vw;
  margin-right: 2.2vw;
}
.image {
  width: 30vw;
  margin: auto;
}
.image img {
  width: 30vw;
}
.flexbox {
  width: 100%;
  /* height: 60vh; */
  font-family: "Poppins", sans-serif;
  font-size: 1.2rem;
  display: flex;
  flex-direction: row;
}
#span {
  width: 6vw;
  padding-bottom: 1vh;
  margin-bottom: 2vh;
  border-bottom: 4px solid rgb(47, 65, 223);
}
#secondslide {
  /* position: absolute; */
  margin-left: 22vw;
  width: 78vw;
  /* top: 100vh; */
  overflow-x: hidden;
  overflow-y: hidden;
}
.headingsecondslide {
  font-size: 2.8rem;
  margin: 2.2vw;
  margin-bottom: 20px;
  font-family: "Zen Antique Soft", serif;
  color: #173b6c;
}
@media screen and (max-height: 2000px) and (min-height: 1300px) and (min-width: 1000px) {
  #secondslide {
    /* height: 60vh; */
    overflow-x: hidden;
    /* position: absolute; */
    margin-left: 0;
    /* top: 60vh; */
    overflow: hidden;
    width: 100vw;
  }
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  #secondslide {
    /* height: 100vh; */
    overflow-x: hidden;
    overflow: hidden;
    /* position: absolute; */
    margin-left: 0;
    /* top: 60vh; */
    width: 100vw;
  }
  #span {
    width: 17vw;
    padding-bottom: 1vh;
    margin-bottom: 2vh;
    border-bottom: 4px solid rgb(47, 65, 223);
  }
  .flexbox {
    width: 100%;
    /* height: 60vh; */
    font-family: "Poppins", sans-serif;
    font-size: 1.2rem;
    display: flex;
    flex-direction: column;
  }
  .image {
    width: 80vw;
    margin: auto;
  }
  .image img {
    width: 80vw;
  }
  .textsecond {
    width: 95.6vw;
    margin-left: 2.2vw;
  }
}
</style>
